module.exports = __webpack_public_path__ + "img/step3.ff7118ac.jpg";